"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    WithFieldWrapper: {
      fontFamily: theme['$font-default'],
      fontSize: 12,
      color: theme['$text-color'],
      display: 'flex',
      alignItems: 'stretch',
      '@media (max-width: 500px)': {
        flexDirection: 'column'
      }
    },
    Label: {
      padding: {
        top: 9,
        bottom: 0,
        left: 0,
        right: 0
      },
      width: 142,
      '@media (max-width: 500px)': {
        width: '100%',
        paddingBottom: 6
      }
    },
    FormFeedback: {
      margin: [3, 0],
      maxWidth: 160
    },
    WithFieldInnerWrapper: {
      flexGrow: 1
    },
    OptionalHelper: {
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'row',
      flexGrow: 1,
      alignItems: 'stretch'
    },
    Optional: {
      padding: '0 0 0 7px',
      lineHeight: '31px',
      fontStyle: 'italic',
      flexGrow: 1
    },
    WrappedComponent: {
      '@media (max-width: 500px)': {
        '&, &[type], &[disabled], &[readonly], &[type][disabled], &[type][readonly]': {
          width: '100%'
        }
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map